var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteBinIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6668 3.16667H10.3335V1.83333C10.3335 1.47971 10.193 1.14057 9.94297 0.890524C9.69292 0.640476 9.35379 0.5 9.00016 0.5H5.00016C4.64654 0.5 4.3074 0.640476 4.05735 0.890524C3.80731 1.14057 3.66683 1.47971 3.66683 1.83333V3.16667H0.333496V4.5H1.66683V14.5C1.66683 15.0304 1.87754 15.5391 2.25262 15.9142C2.62769 16.2893 3.1364 16.5 3.66683 16.5H10.3335C10.8639 16.5 11.3726 16.2893 11.7477 15.9142C12.1228 15.5391 12.3335 15.0304 12.3335 14.5V4.5H13.6668V3.16667ZM5.00016 1.83333H9.00016V3.16667H5.00016V1.83333ZM11.0002 14.5C11.0002 14.6768 10.9299 14.8464 10.8049 14.9714C10.6799 15.0964 10.5103 15.1667 10.3335 15.1667H3.66683C3.49002 15.1667 3.32045 15.0964 3.19543 14.9714C3.0704 14.8464 3.00016 14.6768 3.00016 14.5V4.5H11.0002V14.5Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.33333 7.16602H5V12.4993H6.33333V7.16602Z",
    fill: "#374957"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.00033 7.16602H7.66699V12.4993H9.00033V7.16602Z",
    fill: "#374957"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBinIcon2);
export default __webpack_public_path__ + "static/media/deleteBinIcon2.f94e0cc5f41076ff719da2b67a87dd42.svg";
export { ForwardRef as ReactComponent };